











































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePreferential from "./create-preferential.vue";
import EditPreferential from "./edit-preferential.vue";
import CreateClosure from "../closure/create-closure.vue";
import Ajax from "../../lib/ajax";
class PagePreferentialRequest extends PageRequest {
  startDate: Date = null;
  endDate: Date = null;
  courtName:string="";
}

@Component({
  components: { CreatePreferential, EditPreferential, CreateClosure },
})
export default class Preferentials extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PagePreferentialRequest = new PagePreferentialRequest();
  courtList: Array<object> = [];
  createModalShow: boolean = false;
  editModalShow: boolean = false;

  get list() {
    return this.$store.state.preferential.list;
  }
  get loading() {
    return this.$store.state.preferential.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("preferential/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("preferential/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("preferential/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters

    await this.$store.dispatch({
      type: "preferential/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.preferential.pageSize;
  }
  get totalCount() {
    return this.$store.state.preferential.totalCount;
  }
  get currentPage() {
    return this.$store.state.preferential.currentPage;
  }
  menuClick(name, row) {
    switch (name) {
      case "edit":
        this.$store.commit("preferential/edit", row);
        this.edit();
        break;
      case "delete":
        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("DeleteWarningMessage"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: async () => {
            await this.$store.dispatch({
              type: "preferential/delete",
              data: row,
            });
            await this.getpage();
          },
        });
        break;
      default:
        break;
    }
  }
  columns = [
    {
      title: this.L("StartDate"),
      key: "startDate",
      width: 100,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.startDate).toLocaleDateString());
      },
    },
    {
      title: this.L("EndDate"),
      key: "endDate",
      width: 100,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.endDate).toLocaleDateString());
      },
    },
    {
      title: this.L("IncludeCourts"),
      key: "courtNames",
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 80,
      align: "center",
      slot: "action",
    },
  ];
  async created() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
    this.getpage();
  }
}
